module.exports = __webpack_public_path__ + "static/media/soup.72ae8343.svg";